import React from 'react'
import _cx from 'classnames/bind'
import { Text, Icon, PopupTooltip } from '@adc/ui-adc'
import {
  MATCH_BID_TOOLTIP_CONTENT,
  RESERVE_TOOLTIP_CONTENT_1,
  RESERVE_TOOLTIP_CONTENT_2,
  BID_DEPOSIT_TOOLTIP_CONTENT,
} from '../../../constants/tooltip'
import analytics, { BID_DEPOSIT_EVENT_NAME } from '../../../services/analytics'
import { ONLINE_BID_DEPOSIT_LEARN_MORE_URL } from '../../../../common/statics'
import cls from './styles.scss'
const cx = _cx.bind(cls)

const PROXY_BID_TOOLTIP_LABEL = "What's a proxy bid?"
const PROXY_BID_TOOLTIP_CONTENT_1 =
  "Don't want to be tied to your computer? Enter the maximum amount you are comfortable with."
const PROXY_BID_TOOLTIP_CONTENT_2 =
  'The system will bid on your behalf to keep you in the lead, but only up to your limit.'
export const ProxyBidTooltip = () => {
  return (
    <PopupTooltip
      position='bottom center'
      trigger={
        <Text
          className={cx('tooltip-label')}
          data-elm-id='proxy_bid_tooltip_label'
          size='tiny'
          color='info'
          tabIndex='0'
        >
          {PROXY_BID_TOOLTIP_LABEL}
        </Text>
      }
      content={
        <Text size='tiny' color='white' data-elm-id='proxy_bid_tooltip_content'>
          <p>{PROXY_BID_TOOLTIP_CONTENT_1}</p>
          <p>{PROXY_BID_TOOLTIP_CONTENT_2}</p>
        </Text>
      }
    />
  )
}

const TooltipInfoIcon = props => {
  return (
    <Icon
      {...props}
      className={cx('tooltip-icon')}
      iconStyle='regular'
      name='info-circle'
      color='grayMedium'
      fitted
    />
  )
}

export const ReserveTooltip = () => {
  return (
    <PopupTooltip
      offset={-1}
      position='top center'
      trigger={<TooltipInfoIcon data-elm-id='reserve_tooltip_icon' />}
      content={
        <Text size='tiny' color='white' data-elm-id='reserve_tooltip_content'>
          <p>{RESERVE_TOOLTIP_CONTENT_1}</p>
          <p>{RESERVE_TOOLTIP_CONTENT_2}</p>
        </Text>
      }
    />
  )
}

export const MatchBidTooltip = () => {
  return (
    <PopupTooltip
      offset={-1}
      position='top center'
      trigger={<TooltipInfoIcon data-elm-id='reserve_tooltip_icon' />}
      content={
        <Text size='tiny' color='white' data-elm-id='reserve_tooltip_content'>
          <p>{MATCH_BID_TOOLTIP_CONTENT}</p>
        </Text>
      }
    />
  )
}

const trackBidDepositPopupOpened = () => {
  analytics.popup(`bidding_extended_tooltip`, {
    event: 'hover-event',
    tooltipName: BID_DEPOSIT_EVENT_NAME,
  })
}

export const BidDepositTooltip = () => {
  return (
    <PopupTooltip
      offset={-1}
      position='top center'
      trigger={<TooltipInfoIcon data-elm-id='bid_deposit_tooltip_icon' />}
      content={
        <Text
          size='tiny'
          color='white'
          data-elm-id='bid_deposi_tooltip_content'
        >
          {BID_DEPOSIT_TOOLTIP_CONTENT}
          <a
            target='_blank'
            data-elm-id='bid_deposit_tooltip_learn_more'
            rel='noreferrer'
            href={ONLINE_BID_DEPOSIT_LEARN_MORE_URL}
          >
            Learn More
          </a>
        </Text>
      }
      onOpen={trackBidDepositPopupOpened}
    />
  )
}

const SUBJECT_TO_APPROVAL_TOOLTIP_LABEL = 'Subject to Seller approval'
const SUBJECT_TO_APPROVAL_TOOLTIP_CONTENT =
  'Your high bid did not meet the original Reserve, but the Seller may still accept the bid and approve a sale.'
export const SubjectToApprovalTooltip = () => {
  return (
    <>
      <Text
        content={SUBJECT_TO_APPROVAL_TOOLTIP_LABEL}
        as='span'
        className={cx('u-mr-2')}
      />
      <PopupTooltip
        offset={-1}
        position='bottom center'
        trigger={
          <TooltipInfoIcon data-elm-id='subject_to_approval_tooltip_icon' />
        }
        content={
          <Text
            size='tiny'
            color='white'
            data-elm-id='subject_to_approval_tooltip_content'
          >
            {SUBJECT_TO_APPROVAL_TOOLTIP_CONTENT}
          </Text>
        }
      />
    </>
  )
}

const SUBJECT_TO_CONFIRMATION_TOOLTIP_LABEL = 'Subject to Seller confirmation'
const SUBJECT_TO_CONFIRMATION_TOOLTIP_CONTENT =
  'This Seller requires confirmation of all winning bids, even when the Reserve has been met.'
export const SubjectToConfirmationTooltip = () => {
  return (
    <>
      <Text
        content={SUBJECT_TO_CONFIRMATION_TOOLTIP_LABEL}
        as='span'
        className={cx('u-mr-2')}
      />
      <PopupTooltip
        offset={-1}
        position='bottom center'
        trigger={
          <TooltipInfoIcon data-elm-id='subject_to_confirmation_tooltip_icon' />
        }
        content={
          <Text
            size='tiny'
            color='white'
            data-elm-id='subject_to_confirmation_tooltip_content'
          >
            {SUBJECT_TO_CONFIRMATION_TOOLTIP_CONTENT}
          </Text>
        }
      />
    </>
  )
}

const LOST_RESERVE_NOT_MET_LABEL = 'What happens now?'
const LOST_RESERVE_NOT_MET_CONTENT = (
  <div className={cx('lost-reserve-not-met-content')}>
    If the Reserve is not met, the Seller has several options, including:
    <ul>
      <li>Re-auctioning the property</li>
      <li>Selling the property to the highest bidder.</li>
    </ul>
    These offers are considered "Subject to Seller Approval."
  </div>
)
export const LostReserveNotMetTooltip = () => {
  return (
    <>
      <Text
        content={LOST_RESERVE_NOT_MET_LABEL}
        as='span'
        className={cx('u-mr-2')}
      />
      <PopupTooltip
        offset={-1}
        position='bottom center'
        trigger={
          <TooltipInfoIcon data-elm-id='lost_reserve_not_met_tooltip_icon' />
        }
        content={
          <Text
            size='tiny'
            color='white'
            data-elm-id='lost_reserve_not_met_tooltip_content'
          >
            {LOST_RESERVE_NOT_MET_CONTENT}
          </Text>
        }
      />
    </>
  )
}

const TIME_EXTENSION_LABEL = 'What happened?'
const TIME_EXTENSION_CONTENT = `Bids placed within the final 2 minutes will extend the auction.
 This keeps the auction fair by allowing all bidders to place their own last minute bids.`

export const TimeExtensionTooltip = () => {
  return (
    <PopupTooltip
      position='top right'
      trigger={
        <Text
          className={cx('tooltip-label')}
          color='info'
          data-elm-id='time_extension_tooltip_label'
          size='mini'
        >
          {TIME_EXTENSION_LABEL}
        </Text>
      }
      content={
        <Text
          color='white'
          size='tiny'
          data-elm-id='time_extension_tooltip_content'
        >
          {TIME_EXTENSION_CONTENT}
        </Text>
      }
    />
  )
}
